<div class="not-found-page">
  <div class="not-found-content">
    <img src="assets/images/notfound.svg" alt="">
    <h1>Page not found!</h1>
    <p>Oops, we couldn't find what you are looking for!</p>
  </div>
</div>
